import { FormInstance } from "antd";
import { MessageApi } from "antd/lib/message";
import { ILocationActiveData } from "store/location/location-model";
import { IEditUser, IRolesData } from "store/users/users-model";
import { isJsonString, parseLocation, roleName, searchLocationIdSelected, searchLocationsSelected } from "utils/functions";

type IOnConfirmEditUser = {
  form: FormInstance<any>;
  message: MessageApi;
  messageDescription: string;
  editUser: IEditUser;
  rolesList: Array<IRolesData>;
  locationActiveList: Array<ILocationActiveData>;
  multiLocationsValue: string[];
  visibleMultiLocations: boolean;
  usersUpdateUserAsync: (...args) => void;
};

export const onConfirmEditUser = async ({
  form,
  message,
  messageDescription,
  editUser,
  usersUpdateUserAsync,
  rolesList,
  locationActiveList,
  multiLocationsValue,
  visibleMultiLocations,
}: IOnConfirmEditUser) => {
  try {
    await form.validateFields();
    const jobTitle = form.getFieldValue("jobTitle");
    const language = form.getFieldValue("languageDescription");
    const role = form.getFieldValue("role");
    const location = form.getFieldValue("locationDescription");
    const checkLocation = isJsonString(location);
    let locationId;
    let locationsValue;
    if (!checkLocation) {
      locationId = searchLocationIdSelected(location, locationActiveList);
    }
    const locationSelected = checkLocation && parseLocation(location);
    if (visibleMultiLocations) {
      locationsValue = searchLocationsSelected(multiLocationsValue, locationActiveList);
    }
    const bodyRequest = {
      id: editUser?.id,
      jobTitle,
      roleId: roleName(role, rolesList),
      language,
      location: {
        id: checkLocation ? locationSelected.id : locationId,
        description: checkLocation ? locationSelected.description : location,
      },
      locations: locationsValue ? locationsValue : [],
      allowMultipleLocations: visibleMultiLocations,
    };
    usersUpdateUserAsync(bodyRequest);
  } catch (e) {
    console.log(e);
    console.error(new Error("Edit user form validation error"));
    message.error(messageDescription);
  }
};
